import {
  EnglishDateFormatConverter,
  IManualDateFormatConvertible,
  JapaneseDateFormatConverter
} from ".";

export class ManualDateFormatConverterFactory {
  public static create(language: string): IManualDateFormatConvertible {
    return (language === "en")
     ? new EnglishDateFormatConverter()
     : new JapaneseDateFormatConverter();
  }
}
